import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const Toast = ({ message, type = 'info', onClose, duration = 5000 }) => {
  const [isExiting, setIsExiting] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
    }, 500);
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [handleClose, duration]);

  const config = {
    success: {
      icon: <CheckCircle size={18} />,
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      bg: 'bg-white',
      border: 'border-gray-100'
    },
    error: {
      icon: <AlertCircle size={18} />,
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      bg: 'bg-red-50',
      border: 'border-red-100'
    },
    warning: {
      icon: <AlertTriangle size={18} />,
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      bg: 'bg-white',
      border: 'border-gray-100'
    },
    info: {
      icon: <Info size={18} />,
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      bg: 'bg-white',
      border: 'border-gray-100'
    }
  };

  const style = config[type] || config.info;

  return (
    <div className={`
      flex items-center gap-4 px-6 py-4 rounded-[24px] border shadow-2xl pointer-events-auto
      ${style.bg} ${style.border}
      ${isExiting ? 'animate-fadeOut' : 'animate-slideUp'}
    `}>
      <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${style.iconBg} ${style.iconColor}`}>
        {style.icon}
      </div>
      <span className="font-bold text-sm tracking-tight text-gray-900">
        {message}
      </span>
    </div>
  );
};

export default Toast;
